// Meta Pixel utility
// Pixel ID: 1114319321765860

const PIXEL_ID = '1373950611359910'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

/**
 * Inject the Meta Pixel script and initialize it with the Pixel ID.
 * Safe to call multiple times — only initializes once.
 */
export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  // Set up the fbq queue (standard Meta Pixel pattern)
  const w = window as any
  if (!w.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    w.fbq = n
    if (!w._fbq) w._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
  }

  // Inject the Meta Pixel script tag — append safely to <head>
  // (the standard "insertBefore first script" pattern fails when there
  //  are no script tags in the document, e.g. ES module bundlers.)
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const target = document.head || document.body || document.documentElement
  target.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

/**
 * Track a standard Meta Pixel event.
 */
export function trackEvent(event: string, params?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.fbq) return
  if (params) {
    window.fbq('track', event, params)
  } else {
    window.fbq('track', event)
  }
}
